import React, { useState, forwardRef, useImperativeHandle } from "react"
import { useNavigate } from "react-router-dom";
import SidebarIconButton from "./SidebarIconButton.tsx";
import HomeIconButton from "./HomeIconButton.tsx";

export interface SidebarRef {
    getIsOpen: () => boolean;
    toggleSidebar: () => void;
}

const Sidebar = forwardRef<SidebarRef>(function Sidebar({dirs, title}, ref) {
    const [isOpen, setIsOpen] = useState(true);
    const navigate = useNavigate();
    const items = dirs.map((name, index) => {
        return (
            <li className="hover:bg-gray-700 p-2" key={index}><a href={`#${name}`}>{name}</a></li>
        );
    });
    const onHomeClick = (e) => {
        navigate("/");
    }
    const onSidebarClick = (e) => {
        console.log("set is open to: ", !isOpen);
        setIsOpen(prev => !prev);
    }
    useImperativeHandle(ref, () => {
        return {
            getIsOpen() {
                return isOpen;
            },
            toggleSidebar() {
                setIsOpen(prev => !prev);
            }
        }
    })
    //overflow-y-auto needs a height for the overflow -> h-screen
    return ( 
        <div className="icon-button-hover">
            <div className={`sidebar rounded-r-lg h-screen text-white transition-all duration-300 ease-in-out 
                ${isOpen ? 'w-64' : 'w-0'} overflow-hidden shadow-sm shadow-white`}
                style={{backgroundColor: "var(--surface1)"}}
                >
                <div className="flex items-start w-full space-x-3 text-white h-10">
                    <HomeIconButton onClick={onHomeClick}/>
                    <h1 className="text-2x1 font-bold p-4 underline">{title}</h1>
                    <SidebarIconButton onClick={onSidebarClick}/>
                </div>
                <div className={`h-screen overflow-y-auto`}>
                    <ul className="mt-4">
                        {items}
                    </ul>
                </div>
            </div>
            
            <div className={`fixed rounded-br-lg shadow-sm shadow-white z-50 sidebar top-0 left-0 text-white transition-all ease-in-out
                 ${isOpen ? "opacity-0 pointer-events-none" : "opacity-100 pointer-events-auto"}`} style={{backgroundColor: "var(--surface1)"}}>
                <div className="flex-col items-center justify-center h-full rounded">
                    <HomeIconButton onClick={onHomeClick}/>
                    <SidebarIconButton onClick={onSidebarClick}/>
                </div>
            </div>
        </div>
    )
})

export default Sidebar;